import {
  ActionDotsIcons,
  DeleteIcon,
  EditIcon,
} from "../../../assets/icons/iconsProvider";
import {
  buttonNameConstants,
  buttonTypeConstants,
  SET_BY_MARGIN_OPTIONS,
} from "../../../constants";
import {
  Button,
  CustomTooltip,
  TableCustomCellWrapper,
} from "../../components";
import TableCustomAppliesToField from "../../components/table/TableCustomAppliesToField";
import TableCustomPriceRangeField from "../../components/table/TableCustomPriceRangeField";
import { getActionColumnOfReactDataTableComponent } from "./generic";

const getPresetPricesColumns = (...props) => {
  const { handleEditClick, handleDeleteClick } = props;
  return [
    {
      id: "setBy",
      name: "Set By",
      selector: (row) => row.marginType,
      cell: (row) => {
        return (
          <TableCustomCellWrapper
            cellValue={
              SET_BY_MARGIN_OPTIONS.find(
                (item) => item.value === row.markupType
              ).label
            }
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "appliesTo",
      name: "Applies To",
      selector: (row) => row.markupGroup,
      cell: (row) => {
        return (
          <TableCustomAppliesToField
            row={row}
            groupArray={row.markupGroup}
            groupType={row.markupType}
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "priceRange",
      name: "Price Range",
      selector: (row) => row.maxPriceRange,
      cell: (row) => {
        return <TableCustomPriceRangeField row={row} />;
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "markupPercentage",
      name: "Markup Percentage",
      selector: (row) => row.markupPercentage,
      cell: (row) => (
        <TableCustomCellWrapper cellValue={`${row.markupPercentage}%`} />
      ),
      sortable: true,
      sortDirection: null,
    },
    getActionColumnOfReactDataTableComponent((row) => {
      return (
        <>
          <CustomTooltip anchorSelect={`#tool${row.id}`}>
            <Button
              label={buttonNameConstants.EDIT}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={EditIcon}
              handleClick={() => handleEditClick(row)}
            />
            <Button
              label={buttonNameConstants.DELETE}
              className="w-100"
              type="button"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={DeleteIcon}
              handleClick={() => handleDeleteClick(row.id)}
            />
          </CustomTooltip>
          <button id={`tool${row.id}`} className="action-Button-Wrapper">
            <ActionDotsIcons className="cursor-pointer" />
          </button>
        </>
      );
    }),
  ];
};
export { getPresetPricesColumns };
